import React from 'react';
import { Box, Button, Text, Flex } from '@chakra-ui/react';

const StoreClosedNotification = ({
    storeClosedModalBackgroundColor,
    storeClosedModalBorderRadius,
    storeClosedModalPadding,
    storeClosedModalTextColor,
    storeClosedModalTextSize,
    storeClosedModalCloseButtonColor,
    storeClosedModalCloseButtonSize,
  }) => {
  return (
    <Box
      bg={storeClosedModalBackgroundColor}
      p={storeClosedModalPadding}
      borderRadius={storeClosedModalBorderRadius}
      boxShadow="lg"
      width="100%"
      maxWidth="500px"
      mx="auto"
      mt={10}
    >
      <Flex direction="column" align="center">
        {/* Header Text */}
        <Text fontSize={storeClosedModalTextSize} fontWeight="bold" color={storeClosedModalTextColor} textAlign="center">
          Store Closed
        </Text>

        {/* Description Text */}
        <Text fontSize={storeClosedModalTextSize} color={storeClosedModalTextColor} textAlign="center" mt={3}>
          This Store is now closed and no longer accepting orders.
        </Text>

        <Text fontSize={storeClosedModalTextSize} color={storeClosedModalTextColor} textAlign="center" mt={2}>
          We will be back at 2:00 PM.
        </Text>

        {/* Exit Button */}
        <Button
          onClick={() => alert('Exit clicked')}
          backgroundColor={storeClosedModalCloseButtonColor}
          variant="link"
          size="md"
          fontSize={storeClosedModalCloseButtonSize}
          color="#4A90E2"
          mt={5}
          _hover={{ textDecoration: 'underline' }}
        >
          Exit
        </Button>
      </Flex>
    </Box>
  );
};

export default StoreClosedNotification;
